import ApiAccounts from "api/ApiAccounts"
import useHandleApiError from "hooks/useHandleApiErrors"

import { useCallback, useMemo } from "react"
import { useMutation, useQueryClient } from "react-query"
import { ACCOUNTS_FETCH } from "reducers/accounts/actions-types"

export type AccountSubmitTypes = "create" | "update" | "delete"

const useAccountRequest = (id: string, submitType: AccountSubmitTypes, onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  const successAction = useCallback(() => {
    onSuccess?.()
    queryClient.invalidateQueries(ACCOUNTS_FETCH)
  }, [onSuccess])

  const { getErrorMessageAndShowErrorToast } = useHandleApiError()

  const updateAccount = useMutation({
    mutationFn: async (data: App.AccountPatchPayload) => {
      return new ApiAccounts().patch(data, id)
    },
    onSuccess: successAction,
    onError: (error) => {
      getErrorMessageAndShowErrorToast(error, "Não foi possível atualizar a conta.")
    }
  })

  const isLoading = useMemo(() => {
    return updateAccount.isLoading
  }, [updateAccount])

  const onSubmit = useCallback(
    (data: App.AccountPatchPayload) => {
      switch (submitType) {
        case "update":
          updateAccount.mutate(data)
          break
        default:
          break
      }
    },
    [submitType]
  )

  return {
    onSubmit,
    isLoading
  }
}

export default useAccountRequest
